import { TFunction } from "i18next";
import { ProviderContext } from "notistack";

export function handleDepartmentUpdateError(
  err: any,
  enqueueSnackbar: ProviderContext["enqueueSnackbar"],
  t: TFunction
) {
  const descAlreadyExists = "A costcenter with this name already exist.";

  if (err.response.data.message === descAlreadyExists) {
    enqueueSnackbar(t("A department with this name already exists"), { variant: "error" });
  } else {
    enqueueSnackbar(t("There was a server error"), { variant: "error" });
  }
}
